import { render, staticRenderFns } from "./takeNotes.vue?vue&type=template&id=78fc4de8&scoped=true&"
import script from "./takeNotes.vue?vue&type=script&lang=js&"
export * from "./takeNotes.vue?vue&type=script&lang=js&"
import style0 from "./takeNotes.vue?vue&type=style&index=0&id=78fc4de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc4de8",
  null
  
)

export default component.exports